import { PieChart } from "@mui/x-charts";
import styled from "styled-components";

const PAGE_INLINE_PADDING = "60px";
const PAGE_INLINE_PADDING_MOBILE = "16px";
const FILTER_GAP = "16px";

export const HeaderFilter = styled.div`
    display: flex;
    align-items: center;
    gap: ${FILTER_GAP};
    padding: 0 ${PAGE_INLINE_PADDING};
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        padding: 0 ${PAGE_INLINE_PADDING_MOBILE};
    }
`;

export const FilterFields = styled.div`
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    align-items: center;
    gap: ${FILTER_GAP};

    > .filter-field {
        flex: 1 1 180px;
        min-width: 160px;
        max-width: 260px;
    }

    > .filter-field--switch {
        flex: 1 1 240px;
        min-width: 220px;
        max-width: 340px;
        margin: 0;
    }

    @media (max-width: 768px) {
        width: 100%;

        > .filter-field {
            max-width: none;
            width: 100%;
        }
    }
`;

export const FilterActions = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
    flex-shrink: 0;

    @media (max-width: 768px) {
        margin-left: 0;
        width: 100%;

        button {
            width: 100%;
        }
    }
`;

export const Info = styled.div`
    padding: 12px ${PAGE_INLINE_PADDING} 0;
    font-size: 10pt;
    box-sizing: border-box;

    @media (max-width: 1200px) {
        text-align: center;
    }

    @media (max-width: 768px) {
        padding: 12px ${PAGE_INLINE_PADDING_MOBILE} 0;
    }
`;

export const ChartContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 20px ${PAGE_INLINE_PADDING};
    justify-content: center;
    gap: ${FILTER_GAP};
    box-sizing: border-box;

    .flexing {
        flex: 0 0 calc(50% - 10px);
        box-sizing: border-box;
        min-width: 500px;

        @media (max-width: 850px) {
            flex: 1;
            min-width: 0;
        }
    }

    @media (max-width: 768px) {
        padding: 20px ${PAGE_INLINE_PADDING_MOBILE};
    }
`;

export const BillingContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border-top: 4px solid var(--primary);
`;

export const PieContainer = styled.div`
    padding: 5px;

    h3 {
        margin-bottom: 10px;
    }
`;

export const ContentPie = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Pie = styled(PieChart)``;

export const FinancialContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100px;
    gap: 10px;

    h3 {
        margin-bottom: 10px;
    }
`;

export const FinancialCard = styled.div`
    height: 50px;
    padding: 0px 30px;
    background-color: #bbbbbb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    > div {
        display: flex;
        align-items: center;
        gap: 4px;
        text-align: left;
    }

    > span {
        margin-left: auto;
        text-align: right;
        white-space: nowrap;
        font-weight: 600;
    }
`;

export const ContentFilterHeader = styled.div`
    padding: 0 ${PAGE_INLINE_PADDING};
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${FILTER_GAP};
    margin-bottom: 10px;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 0 ${PAGE_INLINE_PADDING_MOBILE};
        flex-direction: column;
        align-items: stretch;
        margin: 1rem 0;
    }
`;

export const ContentSelectStatus = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${FILTER_GAP};
    margin-left: auto;

    @media (max-width: 768px) {
        margin-left: 0;
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    }
`;

export const ContentStatus = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${FILTER_GAP};
    min-width: 220px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;
        min-width: 0;
        width: 100%;
    }
`;

export const ItemInput = styled.div`
    margin: 1rem;
`;

export const ContentResendInvoices = styled.form`
    display: flex;
    align-items: center;
    gap: 20px;
`;

export const BillingTable = styled.div`
    padding: 0 ${PAGE_INLINE_PADDING};
    margin: 0;
    height: 650px;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 0 ${PAGE_INLINE_PADDING_MOBILE};
    }
`;

export const Page = styled.div`
    background-color: #fff;
    padding: 20px;
`;

export const ContentGraph = styled.div`
    width: 100%;
    height: 500px;
    margin-bottom: 60px;
    padding: 0 ${PAGE_INLINE_PADDING};
    box-sizing: border-box;
`;

export const ContentPagination = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 1rem ${PAGE_INLINE_PADDING};

    @media (max-width: 768px) {
        margin: 1rem ${PAGE_INLINE_PADDING_MOBILE};
    }
`;

export const ExportDiv = styled.div`
    display: flex;
    justify-content: flex-end;
`;
